import type { TooltipProps } from "@material-ui/core";
import { Tooltip as MuiTooltip } from "@material-ui/core";
import type { Theme } from "@material-ui/core/styles";
import { createStyles, withStyles } from "@material-ui/core/styles";

const styles = (theme: Theme) =>
  createStyles({
    tooltip: {
      backgroundColor: theme.palette.primary.dark,
      fontSize: theme.typography.pxToRem(12),
    },
    arrow: {
      color: theme.palette.primary.dark,
    },
  });

const Tooltip: React.ComponentType<TooltipProps> = withStyles(styles)(MuiTooltip);

export default Tooltip;
